import { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { UnifiedJournalEntry } from '../components/UnifiedJournalEntry';
import { Link, useLocation } from 'react-router-dom';

export function JournalPage() {
  const location = useLocation();
  const { promptText, coachingTopicId } = location.state || {};
  const [selectedDate] = useState(new Date());
  const [loading] = useState(false);

  function loadEntries() {
    // Just trigger a refresh if needed
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-8">
      <div className="max-w-3xl mx-auto px-4">
        {/* Simple Header */}
        <div className="mb-8">
          <Link
            to="/app"
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4 transition-colors"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Back
          </Link>
          <h1 className="text-4xl font-heading font-bold text-gray-900 mb-2">Your Journal</h1>
          <p className="text-lg text-gray-600">
            {selectedDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
          </p>
        </div>

        {/* Just the Entry Form */}
        {loading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500"></div>
          </div>
        ) : (
          <UnifiedJournalEntry
            date={selectedDate}
            onSave={loadEntries}
            coachingTopicId={coachingTopicId}
            promptText={promptText}
          />
        )}
      </div>
    </div>
  );
}
